export default {
  name: 'BlankChildrenRoute',
  render: h => h('router-view'),
}
